export const environment = {
  production: true,
  serviceUrl: "https://encompass.iecokc.com/encompass-be/",
  safariBaseUrl: 'https://specialfeaturerequest.app.climatecontrolgroup.com/',
  ratingsBaseUrl: 'https://performance.iecokc.com/',
};
